import Util from './util'

let skinToggle = {
  'getSkin': _getSkin
}

/**

  ---- Function Definition ---

Toggle the skin based on url query param 'skin', or its stored value in cookie.  
skin = 1 is walmart. skin = 2 is samsclub

*/

function _getSkin (urlSkinParam) {
  let _cookies = Util.cookies
  let domain = ((_cookies.read(_cookies.keys.QUERYPARAMS)))
  let queryParamSkin = urlSkinParam

  if (queryParamSkin) {
      /**
       * Check if the url has queryparam 'skin' in it. If yes, skin name.
       * This is mainly for the intial loading of the page from the url link. We remove the query param from url
       * and store it in the cookie after the initial load
       */

    if (queryParamSkin == 1) {
      return 'walmart'
    } else if (queryParamSkin == 2) {
      return 'sams'
    } else if (queryParamSkin == 6) {
      return 'walmartonline'      
    } else {
      return 'default'
    }
  } else if (domain) {
      /* If the url doesn't have the queryparam 'skin', then we check the cookie,
       * to see if we have previously stored the 'skin' value from the queryparam,
       * during the initial loading of the application. If yes, then we return the skin name.
       * This is useful when we refresh the browser to reload the page.
      */

    if (domain.skin != undefined && domain.skin != null && domain.skin == 1) {
      return 'walmart'
    } else if (domain.skin != undefined && domain.skin != null && domain.skin == 2) {
      return 'sams'
    } else if (domain.skin != undefined && domain.skin != null && domain.skin == 6) {
      return 'walmartonline'      
    } else {
      return 'default'
    }
  } else {
      /* If there was no queryparam 'skin' in the url link for initial load of the application, then we resort to returning the default skin name.
      */

    return 'default'
  }
}

export default skinToggle



// WEBPACK FOOTER //
// ./src/util/skinToggle.js